// extracted by mini-css-extract-plugin
module.exports = {"container":"events_container__39poz","container__modal":"events_container__modal__1YoKZ","list__check":"events_list__check__1-qU4","list__span":"events_list__span__3x712"};